<template>
  <popup size="custom" @codd_close="$emit('close')">
    <p v-if="error" @click="fetchScheme" v-html="$t('powerpack.imageContainer.schemaPdf.error')"></p>
    <app-loader v-else-if="!img" :msg="$t('powerpack.imageContainer.schemaPdf.imageLoad')"/>
    <img :src="imgBase64" alt="" v-if="imgBase64">
  </popup>
</template>

<script>
import {AxiosDefault, AxiosImage} from '../../mixins/AxiosWrapperMixin';
import Popup from "./Popup";
import AppLoader from "../AppLoader";
import {mapGetters, mapState} from "vuex";
import PowerpackImage from "../step2/PowerpackImage";

import FileDownload from 'js-file-download';


export default {
  name: "PopupBlueprint",

  components: {
    PowerpackImage,
    Popup,
    AppLoader
  },

  data() {
    return {
      img: undefined,
      id: undefined,
      error: false,
      imgBase64: null,
    }
  },

  computed: {
    ...mapState('build', [
      'motor',
      'pump',
      'tank',
      'circuit',
      'valves'
    ]),
    ...mapGetters({
      maxPressure: 'build/maxPressure',
      isMagento: 'preference/isMagento',
    }),
  },

  methods: {
    downloadFileFromUrl(filename, dataUrl) {
      const link = document.createElement("a");
      link.download = filename;
      link.href = dataUrl;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    async fetchScheme() {
      const motor = this.$store.state.motors.all.find(motor => motor.id === this.motor);

      if (motor.pdf_url !== null) {
        this.downloadFileFromUrl('schema.pdf', motor.pdf_url);
        return;
      }

      this.error = false;
      this.img = undefined;
      this.id = undefined;

      let buildLink = await this.$store.dispatch('cart/getBuildId');

      AxiosDefault.post('scheme/build', {
        build: {...this.$store.getters["build/getBuildObject"], buildLink},
        isMagento: this.isMagento,
      }, {
        responseType: 'blob',
      })
          .then((response) => {
            FileDownload(response.data, 'powerpack.pdf');
            this.$emit('close')
          })
          .catch((e) => {
            console.log(e);
            this.error = true;
          });
    },

    download() {
      AxiosImage.get('scheme/download/' + this.id)
          .then(({data}) => {
            this.forceFileDownload(data);
            this.$emit('close')
          });
    },

    forceFileDownload(data) {
      const url = window.URL.createObjectURL(new Blob([data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'scheme.pdf'); //or any other extension
      document.body.appendChild(link);
      link.click();
    },
  },

  created() {
    this.fetchScheme();
  }
}
</script>

<style scoped lang="scss">
.popup-blueprint {
  width: 688px;
  padding: 22px 24px;

  .title {
    font-size: 20px;
    font-family: neue-haas-grotesk-display, sans-serif;
    font-weight: 700;
    color: #3C3C3B;
  }

  .close {
    font-size: 40px;
    transition: all ease 0.3s;
    position: relative;
    color: #A4AFB7;
    opacity: 1;
    text-shadow: none;
    font-weight: 100;
    cursor: pointer;

    &:hover {
      color: darken(#A4AFB7, 60%);
    }
  }

  .blueprint-container {
    max-height: 800px;

    .scheme {
      max-height: inherit;
      max-width: 100%;
      margin-left: 50%;
      transform: translateX(-50%);
    }
  }

  .download {
    margin-left: auto;
    width: 200px;
    display: flex;
    justify-content: space-evenly;

    .dl-text {
      text-decoration: underline;
      font-size: 12px;
      cursor: pointer;
      color: #3C3C3B;

      img {
        display: none;
      }
    }
  }
}
</style>
